
import { Component, Vue, Prop } from "vue-property-decorator"
import { SurveyFragmentFragment } from "@/gql"
import ScaleInput from "@/components/fields/ScaleInput.vue"

@Component({
  components: {
    ScaleInput,
  },
})
export default class SurveyResponseContent extends Vue {
  @Prop() survey!: SurveyFragmentFragment
  @Prop() responsesByQuestionIndex!: any[]
  @Prop() getSelectedAnswer!: (question: SurveyFragmentFragment["questions"][0]) => any[]
}
